import { useTheme } from "@emotion/react";
import { Box, Divider, LinearProgress, Paper, Typography } from "@mui/material";
import dayjs from "dayjs";
import clsx from "clsx";
import DatagridComponent from "../../../../../components/datagridComponent";
import SeverityChip from "../../../../../components/severityChip";
import useStyles from "./styles";

export default function AlertsTable({ rows = [], loading = false }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const columns = [
    {
      field: "alert",
      headerName: "Alerta",
      flex: 2,

      valueFormatter: (params) => params?.replaceAll('"', ""),
    },
    {
      field: "severity",
      headerName: "Severidade",
      flex: 1,
      minWidth: 115,
      renderCell: (params) => (
        <SeverityChip severity={params?.row?.severity} theme={theme} />
      ),
    },
    {
      field: "initialDate",
      headerName: "Horário Ocorrência",
      flex: 1.5,

      valueFormatter: (params) =>
        dayjs.unix(Number(params)).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      field: "recoveryDate",
      headerName: "Horário Recuperação",
      flex: 1.5,

      valueFormatter: (params) => {
        if (!params) {
          return "-";
        }
        return dayjs.unix(Number(params)).format("DD/MM/YYYY HH:mm:ss");
      },
    },
    {
      field: "duration",
      headerName: "Duração",
      flex: 1,

      valueFormatter: (params) => {
        const totalMs = Number(params);
        if (!params || isNaN(totalMs) || totalMs <= 0) {
          return "";
        }
        const yearMs = 31536000000;
        const monthMs = 2592000000;
        const dayMs = 86400000;
        const hourMs = 3600000;
        const minuteMs = 60000;
        const secondMs = 1000;

        let remaining = totalMs;
        const years = Math.floor(remaining / yearMs);
        remaining %= yearMs;

        const months = Math.floor(remaining / monthMs);
        remaining %= monthMs;

        const days = Math.floor(remaining / dayMs);
        remaining %= dayMs;

        const hours = Math.floor(remaining / hourMs);
        remaining %= hourMs;

        const minutes = Math.floor(remaining / minuteMs);
        remaining %= minuteMs;

        const seconds = Math.floor(remaining / secondMs);

        const parts = [];
        if (years > 0) parts.push(`${years}a`);
        if (months > 0) parts.push(`${months}mes`);
        if (days > 0) parts.push(`${days}d`);
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        if (seconds > 0) parts.push(`${seconds}s`);

        return parts.join(" ");
      },
    },
  ];

  return (
    <Paper
      sx={{
        ...styles.paperDatagrid,
        ...(rows?.length > 16 && { height: "500px" }),
      }}
      elevation={theme.palette.mode == "dark" ? 0 : 3}
    >
      {loading && <LinearProgress sx={styles.linearProgress} />}
      <Typography variant="h6" sx={styles.titleDatagrid}>
        Alertas - Visão Geral
      </Typography>
      <Divider />
      <Box
        sx={{
          display: "flex",
          ...(rows?.length > 16 && { height: "445px" }),
        }}
      >
        <DatagridComponent
          title={"Alertas - Visão Geral"}
          rows={rows}
          columns={columns}
          options={{
            getRowClassName: (params) =>
              clsx(
                {
                  "onGoing-row": !params?.row?.recoveryDate,
                  [`severity-${params?.row?.severity}`]:
                    !params?.row?.recoveryDate,
                },
                Number(params?.indexRelativeToCurrentPage) % 2 === 1
                  ? "linha-impar"
                  : "linha-par",
              ),
          }}
        />
      </Box>
    </Paper>
  );
}
